import { VALID_PRODUCTION_CHARACTERS } from '@/constants';

export const isValidJson = (json: string): boolean => {
	try {
		JSON.parse(json);
	} catch (e) {
		return false;
	}
	return true;
};

export const capitalizeFirstLetter = (string: string): string => string.charAt(0).toUpperCase() + string.slice(1);

export const capitalizeFirstLetterOfEachWord = (text: string) => text.replace(/\b\w/g, (char) => char.toUpperCase());

export const isCharacterNameValid = (name: string | null) => {
	if (!name) return false;
	return VALID_PRODUCTION_CHARACTERS.includes(name);
};

export const SANITIZE_OPTIONS = {
	allowedTags: ['strong', 'em', 'b', 'i', 'p', 'br', 'a'],
	allowedAttributes: {
		a: ['href', 'target', 'rel', 'style'],
	},
};

export const sleep = (ms: number) =>
	new Promise<void>((resolve) => {
		setTimeout(resolve, ms);
	});
